import axios from '../../axios-atis'

import * as actionTypes from './actionTypes';

export const fetchAddressBegin = () => ({
    type : actionTypes.FETCH_ADDRESSES_BEGIN
});

export const fetchAddresssSuccess =  addresss  => {
    return {
        type: actionTypes.FETCH_ADDRESSES_SUCCESS,
        payload: { addresss }
    }
};

export const fetchAddresssError = error => {
    return {
        type: actionTypes.FETCH_ADDRESSES_FAILED,
        payload: { error }
    };
};
export const fetchAddresss = (page, pageSize, filtred, sorted) => {
    return dispatch => {
        dispatch(fetchAddressBegin());
        let url = '/addresses';
        axios.get(url)
            .then(response => {
                dispatch(fetchAddresssSuccess(response.data));
            })
            .catch(err => {
                dispatch(fetchAddresssError(err));
            });
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/address.js